import { render } from "./Sales_Commissions.vue?vue&type=template&id=348c9b94"
import script from "./Sales_Commissions.vue?vue&type=script&lang=js"
export * from "./Sales_Commissions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__